'use client';

import dynamic from 'next/dynamic';
import { useEffect, useState } from 'react';

// 懒加载退出意图弹窗，减少首屏 JS 体积
// 延迟到页面空闲后再加载，不影响首屏性能
const LazyExitIntentPopup = dynamic(
  () => import('./ExitIntentPopup').then(m => m.ExitIntentPopup),
  {
    ssr: false,
    loading: () => null,
  }
);

export function ExitIntentPopupClient() {
  const [shouldLoad, setShouldLoad] = useState(false);

  useEffect(() => {
    // 空闲时才加载（3秒后 + 空闲回调）
    const timer = setTimeout(() => {
      if ('requestIdleCallback' in window) {
        (window as any).requestIdleCallback(() => setShouldLoad(true), { timeout: 5000 });
      } else {
        setShouldLoad(true);
      }
    }, 3000);

    return () => clearTimeout(timer);
  }, []);

  if (!shouldLoad) return null;

  return <LazyExitIntentPopup />;
}
